export const EXSBVATRATE_CREATE_RESET = 'EXSBVATRATE_CREATE_RESET'
export const EXSBVATRATE_CREATE_SET_CREATED = 'EXSBVATRATE_CREATE_SET_CREATED'
export const EXSBVATRATE_CREATE_SET_ERROR = 'EXSBVATRATE_CREATE_SET_ERROR'
export const EXSBVATRATE_CREATE_SET_VIOLATIONS = 'EXSBVATRATE_CREATE_SET_VIOLATIONS'
export const EXSBVATRATE_CREATE_TOGGLE_LOADING = 'EXSBVATRATE_CREATE_TOGGLE_LOADING'
